import script from "./ListingCompetitorDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingCompetitorDialog.vue?vue&type=script&setup=true&lang=js"

import "./ListingCompetitorDialog.vue?vue&type=style&index=0&id=34384507&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34384507"]])

export default __exports__